export const numberFormatter = new Intl.NumberFormat('pl-PL', {
   style: 'decimal',
});

export const currencyFormatter = new Intl.NumberFormat('pl-PL', {
   style: 'decimal',
   minimumFractionDigits: 2,
   maximumFractionDigits: 2,
});
